import { useEffect, useRef } from 'react';
import { useDAWStore } from '../store/daw-store';

/**
 * Hook to manage auto-save functionality
 * Requirements: 14.1, 14.2, 14.3, 14.4, 14.5
 * 
 * This hook:
 * - Checks for auto-save every minute
 * - Triggers auto-save when 30 minutes of editing have passed
 * - Manages auto-save snapshot limit (10 max)
 * - Respects auto-save enabled/disabled setting
 */
export const useAutoSave = () => {
  const { autoSaveEnabled, checkAutoSave } = useDAWStore();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  
  useEffect(() => {
    // Only set up interval if auto-save is enabled
    if (!autoSaveEnabled) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }
    
    // Check for auto-save every minute (Requirements 14.1)
    intervalRef.current = setInterval(() => {
      checkAutoSave();
    }, 60 * 1000); // Check every 60 seconds
    
    // Cleanup on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [autoSaveEnabled, checkAutoSave]);
};
